var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": "" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "container is-fluid" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [_vm._v(" Group(s) ")]),
              _c("b-autocomplete", {
                attrs: {
                  data: _vm.$store.state.groups,
                  placeholder: "Pick one",
                  "open-on-focus": "",
                  field: "name",
                },
                on: { select: _vm.selectGroup },
                model: {
                  value: _vm.groupName,
                  callback: function ($$v) {
                    _vm.groupName = $$v
                  },
                  expression: "groupName",
                },
              }),
            ],
            1
          ),
          _vm.selectedGroup
            ? _c("div", { staticClass: "content" }, [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(" Files for " + _vm._s(_vm.selectedGroup.name) + " "),
                ]),
                _c("div", { staticClass: "box" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCategory,
                          expression: "selectedCategory",
                        },
                      ],
                      staticClass: "select",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedCategory = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.categories, function (c) {
                      return _c(
                        "option",
                        { key: c.id, domProps: { value: c } },
                        [_vm._v(" " + _vm._s(c.name) + " ")]
                      )
                    }),
                    0
                  ),
                  _c("h1", { staticClass: "subtitle" }, [
                    _vm._v(" " + _vm._s(_vm.selectedCategory.name) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "box" },
                    [
                      _c(
                        "transition-group",
                        {
                          staticClass: "field is-grouped is-grouped-multiline",
                          attrs: { name: "fade", tag: "div" },
                        },
                        [
                          !_vm.$lodash.isEmpty(
                            _vm.filesForCategory(_vm.selectedCategory.id)
                          )
                            ? _vm._l(
                                _vm.filesForCategory(_vm.selectedCategory.id),
                                function (file) {
                                  return _c(
                                    "div",
                                    { key: file.id, staticClass: "control" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tags has-addons" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "tag is-link" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(file.displayName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("a", {
                                            staticClass: "tag is-delete",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeFile(file)
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              )
                            : _c("div", { key: 0, staticClass: "control" }, [
                                _c("p", [_vm._v("There is no file here.")]),
                              ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.uploadFile.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "control" }, [
                          _c("div", { staticClass: "file has-name is-info" }, [
                            _c(
                              "label",
                              { staticClass: "file-label" },
                              [
                                _c("ValidationProvider", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              staticClass: "file-input",
                                              attrs: {
                                                type: "file",
                                                name: "resume",
                                                required: "",
                                              },
                                              on: { change: _vm.onFileChange },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3282018304
                                  ),
                                }),
                                _vm._m(0),
                                _c("span", { staticClass: "file-name" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.inputFile.name ||
                                          "Click to pick file"
                                      ) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v(" Name "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("ValidationProvider", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.inputDescription,
                                              expression: "inputDescription",
                                            },
                                          ],
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            name: "description",
                                            placeholder: "Description",
                                            required: "",
                                          },
                                          domProps: {
                                            value: _vm.inputDescription,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.inputDescription =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2429956469
                              ),
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("p", { staticClass: "control" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-primary",
                              class: { "is-loading": _vm.isUploading },
                              attrs: { type: "submit" },
                            },
                            [_vm._m(1), _c("span", [_vm._v("Submit")])]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c("hr"),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "file-cta" }, [
      _c("span", { staticClass: "file-icon" }, [
        _c("i", { staticClass: "fa fa-upload" }),
      ]),
      _c("span", { staticClass: "file-label" }, [_vm._v(" Upload ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fa fa-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }